import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CollectionsService } from '../../../collections/service/collections.service';
import { ProductInterface } from '../../interfaces/product.interface';
import { Lightbox } from 'ngx-lightbox';
import { ImagePipe } from 'src/core/pipes/image.pipe';

@Component({
  selector: 'app-experience-the-product',
  templateUrl: './experience-the-product.component.html',
  styleUrls: ['./experience-the-product.component.scss'],
})
export class ExperienceTheProductComponent implements OnInit {
  experienceOpen = false;
  height = 0;
  @ViewChild('content')
  content: ElementRef | undefined;
  public productData!: ProductInterface;
  private readonly productId: string;

  constructor(
    private lightbox: Lightbox,
    private activatedRoute: ActivatedRoute,
    public collectionsService: CollectionsService,
    private imagePipe: ImagePipe
  ) {
    // Liest Url parameter, productID/Artikelnummer, aus
    this.productId = this.activatedRoute.snapshot.params.productId;
  }

  ngOnInit(): void {
    // Lädt Artikeldaten
    this.productData = this.collectionsService.getProductData(
      Number(this.productId)
    );
  }

  // öffnet und schließt Artikel erleben Overlay
  handleExperience(): void {
    if (this.content) {
      this.height = this.content.nativeElement.offsetHeight;
      console.log(this.height);
    }
    this.experienceOpen = !this.experienceOpen;
    if (this.experienceOpen) {
      (
        document.querySelector('.boxed.experience') as HTMLElement
      ).style.transform = 'translateY(-' + this.height + 'px)';
    } else {
      (
        document.querySelector('.boxed.experience') as HTMLElement
      ).style.transform = 'translateY(0px)';
    }
  }

  openLightbox(e: Event, url: string) {
    e.preventDefault();
    e.stopPropagation();
    this.lightbox.open(
      [
        {
          src: this.imagePipe.transform(url),
          caption: '',
          thumb: this.imagePipe.transform(url),
        },
      ],
      0
    );
  }
}
